import { IMaintenances } from '@interfaces/maintenances/IMaintenances'
import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import api from '@services/api/server'

export default class MaintenanceService {
    public static async list(page: number, perPage = 25, search?: string): Promise<IListPaginated<IMaintenances>> {
        if (search === '') {
            search = undefined
        }
        return (
            await api.get<IListPaginated<IMaintenances>>('/maintenances', {
                params: {
                    page,
                    perPage,
                    search,
                },
            })
        ).data
    }
}
